import columns from '../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import UserTypes from '../../../../common/redux/actions/types/UserTypes';

export function getMrdXmlAnalysisReportProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.MRD_XML_ANALYSIS.id,
    mainReportId: ReportDefinitions.MRD_POD_OVERVIEW.id,
    requestParams: {
      originExchangeOffices: [rowInfo.row.mrdImpc],
      destinationExchangeOffices: [],
      direction: ReportDefinitions.MRD_XML_ANALYSIS.reportDirections[0],
      dateField: 'POSTAL_SCAN_DATE',
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export function getOperationalAnalysisReportProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.OPERATIONAL_ANALYSIS.id,
    mainReportId: ReportDefinitions.MRD_POD_OVERVIEW.id,
    requestParams: {
      originExchangeOffices: [rowInfo.row.mrdImpc],
      destinationExchangeOffices: [],
      direction: ReportDefinitions.OPERATIONAL_ANALYSIS.reportDirections[0],
      dateField: 'DESPATCH_CLOSED_DATE',
      carrierCode: 'Total',
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export const ownImpcProps = userType => (state, rowInfo) => {
  const className = userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownImpc ? 'bg-blue-spindle' : '';
  return { className };
};

export default (data, userType) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    PercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('MRD IMPC', 'mrdImpc').withGetProps(ownImpcProps(userType)).withTotalHeader('Total'),
      ],
    },
    {
      Header: 'Overview',
      columns: [
        new NonZeroNumberColumn('Handovers', 'overview.handovers').withGetProps(ownImpcProps(userType)).withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Units', 'overview.units').withGetProps(ownImpcProps(userType)).withTotalHeader(sumTotal),
        new PercentageColumn('% Denested', 'overview.pctDenested').withGetProps(ownImpcProps(userType)),
        new PercentageColumn('% Attributed', 'overview.pctAttributed').withGetProps(ownImpcProps(userType)),
      ],
    },
    {
      Header: 'Receptacles operator',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Total', 'receptaclesOperator.total').withGetProps(ownImpcProps(userType)).withTotalHeader(sumTotal), getMrdXmlAnalysisReportProps),
        new NavigationColumn(new NonZeroNumberColumn('Denested', 'receptaclesOperator.denested').withGetProps(ownImpcProps(userType)).withTotalHeader(sumTotal), getOperationalAnalysisReportProps),
        new PercentageColumn('% Denested', 'receptaclesOperator.pctDenested').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['receptaclesOperator.denested', 'receptaclesOperator.total'])),
        new NonZeroNumberColumn('Attributed', 'receptaclesOperator.attributed').withGetProps(ownImpcProps(userType)).withTotalHeader(sumTotal),
        new PercentageColumn('% Attributed', 'receptaclesOperator.pctAttributed').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['receptaclesOperator.attributed', 'receptaclesOperator.total'])),
      ],
    },
  ];
};
